import { combineReducers } from 'redux';

import focusTargetId from './focusTargetId';
import initialTrackedId from './initialTrackedId';
import sequence from './sequence';
import trackedFieldId from './trackedFieldId';
import withinBoundaries from './withinBoundaries';

const trackerReducer = combineReducers({
  focusTargetId,
  initialTrackedId,
  sequence,
  trackedFieldId,
  withinBoundaries,
});

export default trackerReducer;
